import React, { useEffect, useState } from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link, useLocation } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { all_routes } from '../../router/all_routes';
import Pagination from '../../StudyDestination/Australia/Pagination';
import { useSelector } from 'react-redux';



interface BannerProps {
    apiValues: any;
}



const Whatsnew: React.FC<BannerProps> = ({ apiValues }) => {




    const [page, setPage] = useState(1);
    const limit = 3; // item per page


    // const { data: availableScholarshipsSubject, isLoading, isError } = useGetTopScholarshipsFilterApiQuery(queryParams);
    const availableScholarshipsSubject = apiValues

    const universities = apiValues || [];
    const totalItems = availableScholarshipsSubject?.totalItems || 0; // Total count from backend
    const totalPages = Math.ceil(availableScholarshipsSubject?.totalPages)

    const route = all_routes;

    const [selectedItems, setSelectedItems] = useState<boolean[]>([]);

    useEffect(() => {
        if (availableScholarshipsSubject?.length) {
            setSelectedItems(Array(availableScholarshipsSubject?.length).fill(false));
        }
    }, [availableScholarshipsSubject]);

    const handleItemClick = (index: number) => {
        setSelectedItems((prev) => {
            const updated = [...prev];
            updated[index] = !updated[index];
            return updated;
        });
    };
    const whatsnewslider = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* whats new */}
            <div className="feature-section position-relative">
                <div className="container">
                    <ImageWithBasePath
                        src="assets/img/bg/feature-bg-01.png"
                        alt="img"
                        className="bg-star-01 img-fluid"
                    />
                    {/* <ImageWithBasePath
                        src="assets/img/bg/feature-bg-02.png"
                        alt="img"
                        className="bg-star-02 img-fluid"
                    /> */}






                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-5">
                        {(Array.isArray(universities) ? universities : []).map((univ: any, index: number) => (
                            <div
                                key={univ._id || index}
                                className="flex flex-col bg-white rounded-lg shadow-md overflow-hidden"
                            >
                                {/* Image */}
                                {/* <div
                                    className="h-32 w-full bg-center bg-cover"
                                    style={{ backgroundImage: `url(${univ.imageUrl})` }}
                                /> */}
                                  <div className="w-full h-36  rounded-lg"
                                style={{
                                    backgroundImage:`url(${univ.imageUrl})`,
                                    backgroundRepeat:"no-repeat",
                                    backgroundSize:"100% 100%",
                                }}
                                />

                                {/* Content */}
                                <div className="flex flex-col flex-grow p-4">
                                    <h5 className="text-lg font-semibold mb-2">{univ?.title}</h5>
                                    <p className="text-sm text-gray-500 mb-3">{univ?.parentId?.countryName}</p>

                                    {/* Divider */}
                                    <div className="border-b w-full mb-3"></div>

                                    {/* Points */}
                                    <div className="flex-grow">
                                        {(Array.isArray(univ?.pointsDescription) ? univ.pointsDescription : []).map((item: any, idx: number) => (
                                            <p key={idx} className="flex items-center gap-2 mb-2">
                                                <ImageWithBasePath
                                                    className="w-6 h-6"
                                                    source={item?.iconUrl}
                                                    alt="icon"
                                                />
                                                {item?.title}
                                            </p>
                                        ))}
                                    </div>

                                    {/* Button */}
                                            <div className="d-flex align-items-center justify-content-center p-3">
                                        <Link
                                            to={`${route.individualUniversity}/${univ._id}`}
                                           className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center text-center"
                                                    style={{ width: '200px', padding: '10px' }}
                                               >
                                            View Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>


                    {/* Pagination */}
                    {/* <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} /> */}

                </div>
            </div>
        </>

    )
}

export default Whatsnew
